module.exports = __webpack_public_path__ + "static/media/flag-checkered-solid.6d515322.svg";